import { defineFcm } from '../shared/factory';

export const FCM_HIDE_SIGNEES = defineFcm('hide_signees').asBoolean().withDefault(false).toConfig();
